export default "__VITE_ASSET__B6$XGQGI__"